// Helper condivisi del Check-up finanziario: formattazione, escape,
// serializzazione dello stato nell'URL (?d=) e fonti citate nei contenuti.
// Modulo senza DOM: importabile anche dai test Node.

// Fonti dei dati citati nella parte educativa. Ogni numero nel testo deve essere
// verificabile qui: se una cifra non si trova nella fonte, va tolta, non arrotondata.
const SOURCES = {
  istat: 'https://www.istat.it/wp-content/uploads/2024/05/Capitolo-2.pdf',
  ocse: 'https://www.oecd.org/content/dam/oecd/en/publications/reports/2023/12/oecd-infe-2023-international-survey-of-adult-financial-literacy_8ce94e2c/56003a32-en.pdf',
  eurostat: 'https://ec.europa.eu/eurostat/databrowser/view/ilc_mdes04/default/table?lang=it',
  bankitalia: 'https://www.bancaditalia.it/pubblicazioni/indagine-famiglie/bil-fam2022/index.html',
  vanguard: 'https://corporate.vanguard.com/content/corporatesite/us/en/corp/articles/emergency-savings-may-hold-key-financial-well-being.html',
  jpmci: 'https://www.jpmorganchase.com/institute/research/household-income-spending/report-weathering-volatility-2'
};

function cite(key, label) {
  return `<a href="${SOURCES[key]}" target="_blank" rel="noopener">${label}</a>`;
}

const encodeParams = (obj) => {
  try {
    return btoa(encodeURIComponent(JSON.stringify(obj)));
  } catch (error) {
    console.error('encodeParams failed', error);
    return null;
  }
};

const decodeParams = (encoded) => {
  try {
    return JSON.parse(decodeURIComponent(atob(encoded)));
  } catch (error) {
    console.error('decodeParams failed', error);
    return null;
  }
};

const euroFormatter = (() => {
  try {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
      useGrouping: 'always'
    });
  } catch (error) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    });
  }
})();

const euro = (value) => euroFormatter.format(Number.isFinite(value) ? value : 0);

const percent = (value) =>
  `${Math.round(Number.isFinite(value) ? value : 0)}%`;

const formatRate = (value) =>
  `${String(Number((Number.isFinite(value) ? value : 0).toFixed(2))).replace('.', ',')}%`;

const percentPrecise = (value, decimals = 1) =>
  `${(Number.isFinite(value) ? value : 0).toFixed(decimals).replace('.', ',')}%`;

function clampNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

const formatMonthsLabel = (months) => months === 1 ? '1 mese' : `${String(months).replace('.', ',')} mesi`;

const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

/**
 * Tabella di confronto con celle etichettate per il card-mode mobile (≤768px).
 * columns: [{ header, wide?, inline? }]; la prima colonna è l'intestazione di
 * riga e non riceve data-label. rows: array di array di celle (HTML già pronto).
 * Tenere colonne e celle allineate qui è il punto: header e data-label non
 * possono più divergere.
 */
const comparisonTable = (columns, rows) => {
  const head = columns.map((column) => `<th>${column.header}</th>`).join('');
  const body = rows.map((cells) => `<tr>${cells.map((cell, index) => {
    if (index === 0) return `<td>${cell}</td>`;
    const column = columns[index];
    return `<td data-label="${column.header}"${column.wide ? ' data-wide' : ''}${column.inline ? ' data-inline' : ''}>${cell}</td>`;
  }).join('')}</tr>`).join('\n          ');
  return `<div class="finance-table-scroll"><table class="finance-comparison-table">
        <thead>
          <tr>${head}</tr>
        </thead>
        <tbody>
          ${body}
        </tbody>
      </table></div>`;
};

export { cite, encodeParams, decodeParams, euro, percent, formatRate, percentPrecise, clampNumber, formatMonthsLabel, escapeHtml, comparisonTable };
